import { type FC } from 'react';
import { UiSimpleGrid } from '@/lib/ui';
import Registration from './Registration';
import AbstractManagement from './AbstractManagement';
import ContentDeliveryPlatform from './ContentDeliveryPlatform';
import MobileEventApp from './MobileEventApp';
import DigitalPoster from './DigitalPoster';
import LiveStreaming from './LiveStreaming';
import SponsorExhibitor from './SponsorExhibitor';
import Webinar from './Webinar';
import DataInsight from './DataInsight';
import { SubscriptionProduct } from '@/api/constant/subscription';

export interface ModuleListProps {
  modules: SubscriptionProduct[]
}

const ModuleList: FC<ModuleListProps> = ({
  modules
}) => {
  return (
    <>
      <UiSimpleGrid columns={{ base: 1, '2xl': 2 }} gap={8}>
        {modules.includes(SubscriptionProduct.Registration) && (
          <Registration isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.EventWebsite) && (
          <ContentDeliveryPlatform isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.Webinar) && (
          <Webinar isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.SponsorExhibitor) && (
          <SponsorExhibitor isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.LiveStreaming) && (
          <LiveStreaming isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.DataInsight) && (
          <DataInsight isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.AbstractManagement) && (
          <AbstractManagement isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.DigitalPoster) && (
          <DigitalPoster isSelected={true} px={0} py={0} />
        )}
        {modules.includes(SubscriptionProduct.MobileEventApp) && (
          <MobileEventApp isSelected={true} px={0} py={0} />
        )}
      </UiSimpleGrid>
    </>
  );
};

export default ModuleList;
